import React from 'react';

import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';
import imagePPALogo from '../../images/logo_ppa.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_saveWater.md';
import markdownFileLevel2 from './level2_keepSavingWater.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) }
};

export function preloadMissionAssignment () {
  preloader([
    imagePPALogo,
    ianSaraSide,
    ianSaraLeanQuestioning
  ]);
}

function missionAssignmentSection ({ level, regionData }) {
  const md = levels[level].md;
  return (
    <Section id="mission-assignment">

      {/* Sizzle */}
      { (level === 1) &&
        headingSlide({
          id: 'sizzle',
          beforeImage: imagePPALogo,
          subHeading: `Mission ${level}`,
          notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
          bgColor: 'black'
        })
      }

      {/* Mission Intro Video*/}
      { (level === 1) &&
        videoSlide({
          id: 'mission-intro-video',
          notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
        })
      }

      {/* Mission Instructions level 1 only */}
      { (level === 1) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: ianSaraSide,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/h2whoaHybrid/sections/70_missionAssignment/missionAssignmentSection.jsx